import { useNavigationModel } from "./model";
import { NavBarContainer, NavBarItem, NavBarAccountDrawer } from "./ui";

type NavigationBarProps = {
  navMargin?: string;
};

export function NavigationBar({
  navMargin = "bottom-3",
}: NavigationBarProps = {}) {
  const {
    isAuthenticated,
    navItems,
    isActive,
    handleNavClick,
    username,
    role,
    balance,
    storeBalance,
    store,
    isAccountMenuOpen,
    setIsAccountMenuOpen,
    accountDrawerView,
    setAccountDrawerView,
    openDepositDialog,
    openWithdrawDialog,
  } = useNavigationModel();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      <NavBarContainer navMargin={navMargin}>
        {navItems.map((item) => (
          <NavBarItem
            key={item.type}
            type={item.type}
            labelKey={item.labelKey}
            isActive={isActive(item.path)}
            badgeCount={item.badgeCount}
            onClick={() => handleNavClick(item)}
          />
        ))}
      </NavBarContainer>

      <NavBarAccountDrawer
        username={username}
        role={role}
        balance={balance}
        store={store}
        storeBalance={storeBalance ?? undefined}
        isOpen={isAccountMenuOpen}
        onOpenChange={setIsAccountMenuOpen}
        accountDrawerView={accountDrawerView}
        setAccountDrawerView={setAccountDrawerView}
        onTopUp={openDepositDialog}
        onWithdraw={openWithdrawDialog}
      />
    </>
  );
}
